import React from 'react';
import { Participant } from '../types';

interface Props {
  participants: Participant[];
}

const ParticipantList: React.FC<Props> = ({ participants }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {participants.map((p) => (
        <div
          key={p.id}
          className="flex items-center gap-2 bg-white rounded-full px-3 py-1.5 shadow-sm border"
        >
          <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center text-white font-bold text-sm">
            {p.nickname.charAt(0).toUpperCase()}
          </div>
          <span className="text-sm font-medium text-gray-700">
            {p.nickname}
          </span>
          {p.isCreator && (
            <span className="text-xs bg-orange-100 text-orange-600 px-1.5 py-0.5 rounded-full">
              host
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default ParticipantList;
